import * as Types from '../../../../../../../generated/base-types';

import { gql } from 'apollo-angular';
import { ExamDetailsFragmentDoc } from './load-exam.generated';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type LoadExamListQueryVariables = Types.Exact<{
  poolId: Types.Scalars['ID'];
}>;


export type LoadExamListQuery = { __typename?: 'Query', pool: { __typename?: 'Pool', exams: Array<{ __typename?: 'Exam', id: string, name: string, date: string, duration?: number | null, medium?: string | null, typ?: string | null, has_scrambling_b?: boolean | null, number_of_additional_scramblings?: number | null, locked_at_date?: string | null, de: boolean, en: boolean, fr: boolean, it: boolean, show_first_dimension_presort?: boolean | null, allow_question_comments?: boolean | null, first_presort_criterion?: boolean | null, second_presort_criterion?: boolean | null, third_presort_criterion?: boolean | null, locked: boolean, self_assessed: boolean, is_in_the_future: boolean, provisioned: boolean, examinator_unlock_token?: string | null, content: { __typename?: 'TranslatedContent', de?: string | null, en?: string | null, fr?: string | null, it?: string | null }, presort_criteria: Array<{ __typename?: 'PresortCriteria', type?: string | null, name?: string | null, position?: number | null }> }> } };

export const LoadExamListDocument = gql`
    query LoadExamList($poolId: ID!) {
  pool(id: $poolId) {
    exams(includePaperExams: true, sort: {attribute: DATE, direction: DESC}) {
      ...ExamDetails
    }
  }
}
    ${ExamDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadExamListGQL extends Apollo.Query<LoadExamListQuery, LoadExamListQueryVariables> {
    document = LoadExamListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }